const deprecatedKeywords = ["backdrop:", "link:"]

const replaceKeyword = {
    "backdrop:": "background:",
    "link:": "{{"
}

const keywordsRegEx = new RegExp(`^((${deprecatedKeywords.join(")|(")}))(.*)$`)

export function updateDeprecatedTokens(code: string): string {
    const lines = code.split("\n")
    lines.forEach((line, idx) => {
        const test = keywordsRegEx.exec(line)
        if (test) {
            if (test[1] === "link:") {
                line += "}}"
                lines[idx] = line.replace(test[1] + " ", replaceKeyword[test[1]])
                lines[idx] = line.replace(test[1], replaceKeyword[test[1]])

            } else {
                //@ts-expect-error: fix this
                lines[idx] = line.replace(test[1], replaceKeyword[test[1]])
                if (test[1] === "link:") line += "}}"
            }
        }
    })

    const updated = lines.join("\n")

    return updated
}



